
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'

export default {
props:{
step:{
type:Number,
required:true
}
},
components: { Step, StepItem },
data(){
return { }
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/components/dispoit-step.vue